import { useEffect, useState } from "react";
import axios from "axios";
import { APIURL, AUTH_CREDENTIALS_NAME } from "../Constantes";

const getCabecera = () => {
    let Token = localStorage.getItem(AUTH_CREDENTIALS_NAME);
    let cabecera = {
        Authorization: `bearer ${Token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
    }
    return cabecera;
}

export const useDetalleCorte = ({idCorte}) => {
    const [movimientos, setMovimientos] = useState([]);
    useEffect(() => {
        const getIsActivo = async () => {
            return await axios.get(`${APIURL}/CashRegister/TransactionsUSD/${idCorte}`,
                {
                    headers: getCabecera()
                }).then(Response => {
                    setMovimientos(Response.data)
                }).catch(Error => {
                    setMovimientos([])
                })
        }
        getIsActivo();
        return () => {
            setMovimientos([])
        }
    }, [idCorte])
    return [movimientos];
}